export const Keys = {
    Tab: 9,
    Enter: 13,
    Esc: 27,
    Space: 32,
    Delete: 46,
    Alt: 18,
    O: 79,
    P: 80,
    S: 83,
    Y: 89,
    Z: 90
};